import { Modal, Form, Button, Col, Dropdown, Input, Layout, List, Menu, message, Row, Space, Select, Spin, Tooltip, FormInstance, ModalProps } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ProFormInstance, ProFormText, ProFormTextArea, ProFormDigit, ProFormRadio, ModalForm } from '@ant-design/pro-form'

export type OrderItemDiscountRequest = {
  discountPrice: number;
  discountDollar: number;
  discountPercent: number;
  comment: string;
};

export type OrderItemDiscountFormProps = {
  visible: boolean;
  onCancel: any;
  onSubmit: (values: OrderItemDiscountRequest) => Promise<void>;
  /** @name 弹框的标题 */
  title?: ModalProps['title'];
  width?: any;
  formValues?: any;
};

const OrderItemDiscountForm: React.FC<OrderItemDiscountFormProps> = (props) => {
  const formRef = useRef<ProFormInstance<any> | undefined>();
  const [newValue, setNewValue] = useState<any>({})
  return (
    <ModalForm title={props.title}
      grid={true}
      visible={props.visible}
      autoFocusFirstInput
      initialValues={props.formValues}
      modalProps={{
        destroyOnClose: true,
        onCancel: () => { props.onCancel(); },
      }}
      onFinish={async (values) => {
        props.onSubmit({ ...values })
      }}
      layout="horizontal"
      autoComplete="off"
      onValuesChange={(value, all) => { console.log(newValue); setNewValue({ ...newValue, ...all }); }}
      formRef={formRef} >
      <ProFormDigit name="discountPrice" label="价格($)" colProps={{ md: 24 }} min={0} fieldProps={{ prefix: "$", precision: 2, controls: false }}></ProFormDigit>
      <ProFormDigit name="discountDollar" label="降价($)" colProps={{ md: 24 }} min={0} fieldProps={{ prefix: "$", precision: 2, controls: false }}></ProFormDigit>
      <ProFormDigit name="discountPercent" label="打折(%)" colProps={{ md: 24 }} min={0} fieldProps={{ precision: 0, controls: false }}></ProFormDigit>
    </ModalForm>
  )

};
export default OrderItemDiscountForm
